<template>
	<drawer
			title="Edit account settings"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<div class="accountSettings_body">
			<div class="accountSettings_body-title">Physical address</div>
			<field
					:class-error="getError('physical_address_street')"
					margin="0 0 10px 0"
					width="300px"
					label="Street, building"
					@updateInput="onInput($event, 'physical_address_street')"
					:setInputValue="physical_address_street.setting_value"
			></field>
			<field
					:class-error="getError('physical_address_city')"
					margin="0 0 10px 0"
					width="300px"
					label="City, State, ZIP"
					@updateInput="onInput($event, 'physical_address_city')"
					:setInputValue="physical_address_city.setting_value"
			></field>
			<field
					:class-error="getError('phone')"
					margin="0 0 20px 0"
					width="300px"
					label="Phone"
					@updateInput="onInput($event, 'phone')"
					:setInputValue="phone.setting_value"
					is-phone
			></field>
			<field
					:class-error="getError('identification_number')"
					margin="0 0 20px 0"
					width="300px"
					label="Identification number"
					@updateInput="onInput($event, 'identification_number')"
					:setInputValue="identification_number.setting_value"
					is-identification_number
			></field>
			<field
					:class-error="getError('ein')"
					margin="0 0 20px 0"
					width="300px"
					label="Ein"
					@updateInput="onInput($event, 'ein')"
					:setInputValue="ein.setting_value"
					is-ein
			></field>

			<account-list
					:list="zelleAccount"
					margin="0 0 10px 0"
					@updateAccountEdit="onAccountEdit"
					@updateAccountRemove="onAccountRemove"
			></account-list>

			<div class="accountSettings_body-title">Services</div>
			<field
					v-if="isCreate"
					margin="0 0 10px 0"
					width="300px"
					:setInputValue="serviceItem"
					@updateInput="onInput($event, 'serviceItem')"
					@updateAdd="onAdd"
					is-add
			></field>
			<template v-for="({ id, name, status }, idx) in serviceItemList">
				<div v-if="status" class="serviceItem" :key="id">
					<field
							margin="0 0 10px 0"
							:width="isDelete ? '290px': '300px'"
							:idx="idx"
							@updateInput="onInput"
							:setInputValue="name"
					></field>
					<v-btn
							v-if="isDelete"
							icon
							color="green"
							class="deleteBtn"
							type="button"
							@click="onDeleteService(idx)"
					>
						<svg-sprite width="20" height="20" icon-id="deleteItem"></svg-sprite>
					</v-btn>
				</div>
			</template>
		</div>
	</drawer>
</template>

<script>
// shared
import { mapActions, mapGetters } from "vuex";
import getClonedObject from "@/helper/getClonedObject";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import AccountList from "@/components/Settings/AccountingSettings/AccountList/AccountList.vue";
import Drawer from "@/shared/Drawer/Drawer.vue";

export default {
	name: "AccountSettingsDrawer",
	mixins: [ validationMixin ],
	components: {
		Drawer,
		AccountList,
	},
	props: {
		isCreate: Boolean,
		isDelete: Boolean,
	},
	computed: {
		...mapGetters([ "accountServices", "accountSettings", 'zelleAccount' ]),
	},
	data: () => ({
		physical_address_street: { setting_value: "" },
		physical_address_city: { setting_value: "" },
		phone: { setting_value: "" },
		identification_number: { setting_value: "", status: 1, setting_id: 4, setting_key: "identification_number", },
		ein: { setting_value: "", status: 1, setting_id: 5, setting_key: "ein", },
		serviceItem: '',
		serviceItemList: []
	}),
	validations: {
		physical_address_street: { setting_value: { required } },
		physical_address_city: { setting_value: { required } },
		phone: { setting_value: { required } },
		identification_number: { setting_value: { required } },
		ein: { setting_value: { required } },
		serviceItemList: {
			$each: {
				name: { required },
			}
		}
	},
	methods: {
		...mapActions([ 'onAccountSettingsSave', 'setAlert' ]),
		getError(key) {
			return this.$v[key] && this.$v[key].$error;
		},
		onInput({ value, idx }, key) {
			if (idx !== undefined) {
				this.$set(this.serviceItemList[idx], 'name', value);
			} else if (key === 'serviceItem') {
				this[key] = value;
			} else if (key === 'identification_number') {
				this.$set(this[key], 'setting_value', value);
			} else if (key === 'ein') {
				this.$set(this[key], 'setting_value', value);
			} else {
				this.$set(this[key], 'setting_value', value);
			}
		},
		onDeleteService(idx) {
			this.serviceItemList[idx].status = 0;
		},
		onAdd() {
			this.serviceItemList.push({ name: this.serviceItem, status: 1, id: null, });
			this.serviceItem = "";
		},
		onClose() {
			this.$emit("closeDrawer");
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const zelleAccountListFiltered = this.zelleAccount.map(item => {
					(typeof item.id === 'string') && (item.id = null);
					return item;
				});
				const values = {
					service: this.serviceItemList,
					zelleAccount: zelleAccountListFiltered,
					settings: [
						this.physical_address_street,
						this.physical_address_city,
						this.phone,
						this.identification_number,
						this.ein,
					]
				};
				this.$emit('updateSettings', values);
			} else {
				this.setAlert({ type: 'error', message: 'Should fill all fields' });
			}

		},
		onAccountEdit(value) {
			this.$emit('updateAccountEdit', value);
		},
		onAccountRemove(idx) {
			this.zelleAccount.splice(idx, 1);
		}
	},
	mounted() {
		this.accountSettings.forEach((item) => (this.$data[item.setting_key] = item));
		this.serviceItemList = getClonedObject(this.accountServices);
	},
};
</script>

<style scoped lang="scss">
.serviceItem {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 5px;

	button {
		&[disabled] {
			color: var(--base-color-disabled);
		}
	}
}
.accountSettings_body-title {
	margin: 0 0 10px;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: var(--card-color-sub-title);
}

</style>
